import { render } from "./PinnedEvent.vue?vue&type=template&id=36085b16"
import script from "./PinnedEvent.vue?vue&type=script&lang=js"
export * from "./PinnedEvent.vue?vue&type=script&lang=js"

import "./PinnedEvent.vue?vue&type=style&index=0&id=36085b16&lang=scss"

import exportComponent from "/var/www/basic/vue-about-us/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__